// Common African countries list
export const AFRICAN_COUNTRIES = [
    "Côte d'Ivoire",
    "Sénégal",
    "Cameroun",
    "Bénin",
    "Togo",
    "Burkina Faso",
    "Mali",
    "Niger",
    "Guinée",
    "Gabon",
    "Congo",
    "RDC",
    "Tchad",
    "République Centrafricaine",
    "Mauritanie",
    "Nigéria",
    "Ghana",
    "Kenya",
    "Tanzanie",
    "Rwanda",
    "Burundi",
    "Ouganda",
    "Éthiopie",
    "Maroc",
    "Algérie",
    "Tunisie",
    "Égypte",
    "Afrique du Sud",
    "Madagascar",
    "Autre",
];
